import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React, { Fragment } from 'react';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { Section } from '../../Section';
export var CategoryDescription = function CategoryDescription(_ref) {
  var category = _ref.category;
  return React.createElement(Fragment, null, category.description ? React.createElement(Section, {
    bottomMargin: true
  }, React.createElement(ParagraphSmall, {
    style: {
      maxWidth: '100%'
    }
  }, category.customDescription || category.description)) : null);
};